import { PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import { Checkbox } from '../checkbox';

export type PropertiesPanelCheckboxPropertyProps = {
    id: string;
    label: React.ReactNode;
    checked: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
};
export const PropertiesPanelCheckboxProperty: React.FC<PropertiesPanelCheckboxPropertyProps> = ({ id, label, checked, onChange, disabled }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <Checkbox
                    disabled={disabled}
                    checked={checked}
                    onChange={(checked) => {
                        onChange?.(checked);
                    }}
                />
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
